import React from 'react';
import { Button } from '@mui/material';
import { FilterList as FilterIcon } from '@mui/icons-material';

interface FilterToggleButtonProps {
  showFilters: boolean;
  onToggle: () => void;
}

const FilterToggleButton: React.FC<FilterToggleButtonProps> = ({ showFilters, onToggle }) => {
  return (
    <Button
      variant="outlined"
      startIcon={<FilterIcon />}
      size="small"
      onClick={onToggle}
    >
      {showFilters ? 'Hide Filters' : 'Show Filters'}
    </Button>
  );
};

export default FilterToggleButton; 